// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import { toast } from "./utils/toast"
import "./controllers"

// Make toast available globally for inline scripts and other code
window.toast = toast
